import React, { Component } from 'react';

import AppStore from '../flux/AppStore';
import Constants from '../flux/Constants';
import {__} from "../Translator";
import Footer from "../components/Footer";
import Header from "../components/Header";
import StepIndicator from "../components/StepIndicator";
import AppActions from "../flux/AppActions";

import './Configured.css';
import { thronImageUrl } from '../Helpers';

class ConfiguredScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customProduct: AppStore.getCustomProduct(),
    };

    this.props.navigation.onBack(() => {
      if(this.state.customProduct.custom_colored){
        this.props.navigation.navigate('configurator');
      }else{
        this.props.navigation.navigate('modelFit');
      }
    });

    this.onCustomProductUpdate = this.onCustomProductUpdate.bind(this);
  }

  componentDidMount() {
    AppStore.events.updateCustomProduct.addListener(this.onCustomProductUpdate);
  }

  componentWillUnmount() {
    AppStore.events.updateCustomProduct.removeListener(this.onCustomProductUpdate);
  }

  onCustomProductUpdate() {
    this.setState({ customProduct: AppStore.getCustomProduct() });
  }

  render() {
    const { customProduct } = this.state;
    const { product } = customProduct;

    let imageUrl = null;
    let matchingColor = null;
    if (!customProduct.custom_colored) {
      matchingColor = product.standard_colors.find(color => color.name === customProduct.preset);
      // Use the preview_image_url from the matching color, or fallback to default_color if not found
      imageUrl = matchingColor.preview_image_url

    }

    return (
      <div>
        <Header
          title={__('Configurator')}
        />

        <Footer navigation={this.props.navigation} />

        <StepIndicator currentScreen={this.props.navigation.currentScreen} />

        <div className="main">
          <div className="row">
            <div className="col-xs-8 col-xs-offset-2 text-center">
            <div className="main__hero">
              <h1 className="hero__title">{__('Thank you!')}</h1>
              <div className="hero__text">
                <div>
                  <p>{__('Please look for an email, checking in junk folder as well, with your unique Custom Works code.')}<br />
                  {this.state.customProduct.custom_colored && __('This allows you to view the design at any time. Please note that any changes will create a new code.')}</p>
                  <div className="customizationHash">
                    <p className="customizationHash__text">
                      {__('Your unique Custom Works code code is:')}
                      <span className="customizationHash__code">
                        {this.state.customProduct.hash}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              </div>
              {this.state.customProduct.custom_colored ? (
              <div className="productImageContainer">
                <img alt={__('Product Right')}  src={this.state.customProduct.screenshots.right} className="productImage__right"  />
                <img alt={__('Product front')} src={this.state.customProduct.screenshots.front} className="productImage__front" />
                <img alt={__('Product Back')}  src={this.state.customProduct.screenshots.back} className="productImage__back"  />
                <img alt={__('Product Left')} src={this.state.customProduct.screenshots.left} className="productImage__left" />
              </div>
              ) : (
                <div className="productImageContainer">
                  <img alt={__('Default')}  src={thronImageUrl(imageUrl, '', 1000)} className="productImage__front"  />
                </div>
              )}

              <div className="u-ta-center">
                {this.state.customProduct.custom_colored &&
                  <button className="btn btn-primary not-hover btn-xlg" onClick={() => {
                  AppActions.updateCustomProduct({ hash: null});
                  this.props.navigation.navigate('configurator');
                  }}>
                    {__('Reconfigure')}
                  </button>
                }
                {! this.state.customProduct.custom_fitted &&
                  <a href="https://www.dainese.com?cid=cw-request" target="_blank" rel="noopener noreferrer">
                    <button style={{marginLeft:'1rem'}} className="btn btn-primary white btn-xlg">
                      {__('Buy online')}
                    </button>
                  </a>
                }
                <a href="https://www.dainese.com?cid=cw-centers" target="_blank" rel="noopener noreferrer">
                  <button style={{marginLeft:'1rem'}} className="btn btn-primary white btn-xlg">
                    {__('Buy in store')}
                  </button>
                </a>
                </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConfiguredScreen;



// WEBPACK FOOTER //
// ./src/screens/Configured.js